/**
 * Client-side All / Shoppable / Non-Shoppable filter — same rules as
 * Stay Up To Date Trending (`TrendingProductsDataFront`).
 */
export function normalizeShoppableStatusFilter(
  raw?: string | null,
): "all" | "shoppable" | "non-shoppable" {
  const s = String(raw || "all")
    .toLowerCase()
    .trim();
  if (s === "shoppable") return "shoppable";
  if (s === "non-shoppable" || s === "non_shoppable") return "non-shoppable";
  return "all";
}

export function shoppableStatusFromLabel(
  label?: string | null,
): "all" | "shoppable" | "non-shoppable" {
  if (label === "Shoppable") return "shoppable";
  if (label === "Non-Shoppable") return "non-shoppable";
  return "all";
}

/** True when the post has a real `shop_link` (not external_link / tagged_link). */
export function isPostShoppable(post: unknown): boolean {
  if (!post || typeof post !== "object") return false;
  const row = post as Record<string, unknown>;
  const link =
    typeof row.shop_link === "string"
      ? row.shop_link.trim()
      : typeof row.shopLink === "string"
        ? row.shopLink.trim()
        : "";
  return Boolean(link);
}

export function filterPostsByShoppableStatus<T>(
  posts: T[],
  filter?: string | null,
): T[] {
  const status = normalizeShoppableStatusFilter(filter);
  if (status === "all" || !Array.isArray(posts)) return posts;
  return posts.filter((post) => {
    const shoppable = isPostShoppable(post);
    return status === "shoppable" ? shoppable : !shoppable;
  });
}
